import { BranchRoleMapping, Role } from 'graphql/models/generated';

export const defaultPhoto = 'assets/common/icons/user.svg';

export enum AccountTypeENUM {
  DEALER = 'DEALER',
  MANUFACTURER = 'MANUFACTURER'
}

export enum Manufacturer {
  GARANT = 'GARANT',
  PRUEM = 'PRUEM'
}

export function getManufacturer(value: string): Manufacturer | undefined {
  const upperCasedValue = value.toUpperCase();
  return Manufacturer[upperCasedValue as keyof typeof Manufacturer];
}

export interface CurrentAccountRoles {
  isOrgUser: boolean;
  isOrgAdmin: boolean;
  isOrgSuperAdmin: boolean;
  isBranchUser: boolean;
  isBranchAdmin: boolean;
  isBranchSuperAdmin: boolean;
  branchRoles: BranchRoleMapping[];
  activeBranchRole?: Role;
  activeOrgRole?: Role;
}

export enum AccountRole {
  USER = 'USER',
  ADMIN = 'ADMIN',
  SUPERADMIN = 'SUPERADMIN'
}

export const AllAccountRoles = [
  AccountRole.USER,
  AccountRole.ADMIN,
  AccountRole.SUPERADMIN
];

export enum AccountStatus {
  CREATED = 'CREATED',
  INVITED = 'INVITED',
  ACTIVE = 'ACTIVE',
  DEACTIVATED = 'DEACTIVATED',
  DELETED = 'DELETED'
}

export enum ViewSettingsENUM {
  FUNCTION = 'FUNCTION',
  DESIGN = 'DESIGN'
}

export interface RestrictedRoles {
  dealer?: AccountRole[];
  manufacturer?: AccountRole[];
}
